import ConferenceRepository from '../repository/ConferenceRepository';
import Conference from '../models/Conference';


export default class ConferenceService {
    
    async getConference() {
        try {
            // Uderzamy do Twojej akcji w Yii! (Dostosuj URL, jeśli potrzebujesz ?r=conference/json)
            const response = await fetch('/conference/json'); 
            const result = await response.json();

            // Zwracamy obiekt "data" (czyli to, na co czeka App.js)
            if (result.success) {
                return result.data; 
            } else {
                console.error('Błąd pobierania danych:', result.message);
                return {};
            }
        } catch (error) {
            console.error('Błąd połączenia z API:', error);
            return {};
        }
    }

}
